<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                        icon="pi pi-upload" class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="onFarmerWaterTankItesms"></p-menu>
                </ng-template>

            </p-toolbar>

            <p-table #realtimeDataPdmcSchemeTable [value]="realTimeSoucreListData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['Source_Name','Verified_Apps','Verified_Area_Count','Under_Process_of_Installation', 'Under_Process_Area',
                'Assistance_Disbursed','Disbursed_Area','Disbursed_Amount','Noof_Benficiaries']" responsiveLayout="scroll"
                [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" sortField="Source_Name" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'ON_FARMER_WATER_TANK' | translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="realtimeDataPdmcSchemeTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

                        </th> -->
                        <!-- <th></th> -->
                        <th pSortableColumn="Source_Name">{{'WATER_SOURCE' | translate}}
                            <p-columnFilter type="text" field="Source_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Source_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Apps">{{'APPLICATION_VERIFIED' | translate}}
                            <p-columnFilter type="text" field="Verified_Apps"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Verified_Apps"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Area_Count">{{'AREA_IN_ACRE' | translate}}
                            <p-columnFilter type="text" field="Verified_Area_Count" display="menu"></p-columnFilter>
                            <p-sortIcon field="Verified_Area_Count"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Under_Process_of_Installation">{{'APPLICATION_UNDER_CONSTRUCTION' | translate}}
                            <p-columnFilter type="text" field="Under_Process_of_Installation" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Under_Process_of_Installation"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Under_Process_Area">{{'AREA_IN_ACRE' | translate}}
                            <p-columnFilter type="text" field="Under_Process_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Under_Process_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed">{{'ASSISTANCE_DISBURSED' | translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed" display="menu"></p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Area">{{'AREA_IN_ACRE' | translate}}
                            <p-columnFilter type="text" field="Disbursed_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Amount">{{'AMOUNT_IN_LAKH' | translate}}
                            <p-columnFilter type="text" field="Disbursed_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Noof_Benficiaries">{{'NOOF_BENEFICIARY' | translate}}
                            <p-columnFilter type="text" field="Noof_Benficiaries" display="menu"></p-columnFilter>
                            <p-sortIcon field="Noof_Benficiaries"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td>{{product.Source_Name}}</td>
                        <td>{{product.Verified_Apps}}</td>
                        <td>{{product.Verified_Area_Count}}</td>
                        <td>{{product?.Under_Process_of_Installation}}</td>
                        <td>{{product?.Under_Process_Area}}</td>
                        <td>{{product?.Assistance_Disbursed}}</td>
                        <td>{{product?.Disbursed_Amount}}</td>
                        <td>{{product?.Disbursed_Area}}</td>
                        <td>{{product?.Noof_Benficiaries}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{realTimeSoucreListData ? realTimeSoucreListData.length
                            : 0 }}
                            {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                        </p>
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                        icon="pi pi-upload" class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="districtConsistencyItems"></p-menu>
                </ng-template>

            </p-toolbar>

            <p-table #realtimeDataPdmcScheme2Table [value]="disctrictConsistenceWiseData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['District','Constituency','Application_recevied','Area','Approved', 'Verified_Area_Count', 'Incomplete',
                     'Rejected', 'Pending', 'IntimationStage1', 'VerifiedStage1', 'IntimationStage2', 'VerifiedStage2', 'IntimationStage3', 'VerifiedStage3',
                      'Assistance_Disbursed_Stage1', 'Disbursed_Amount_Stage1', 'Assistance_Disbursed_Stage2','Disbursed_Amount_Stage2',
                      'Assistance_Disbursed_Stage3', 'Disbursed_Amount_Stage3', 'Amount', 'NoofBeneficiary']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" sortField="District" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'DRILL_DOWN_WILL_LEAD_TO_DISTRICT' | translate}}
                        </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="realtimeDataPdmcScheme2Table.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th pSortableColumn="SI">SI
                                <p-columnFilter type="text" field="SI" display="menu"></p-columnFilter>
                                <p-sortIcon field="SI"></p-sortIcon>
                            </th> -->
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                            <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                            <p-sortIcon field="Constituency"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Application_recevied">{{'APPLICATION_RECEIVED'| translate}}
                            <p-columnFilter type="text" field="Application_recevied" display="menu"></p-columnFilter>
                            <p-sortIcon field="Application_recevied"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Area">{{'AREA'| translate}}
                            <p-columnFilter type="text" field="Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Approved">{{'VERIFIED_APP'| translate}}
                            <p-columnFilter type="text" field="Approved" display="menu"></p-columnFilter>
                            <p-sortIcon field="Approved"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Area_Count">{{'AREA'| translate}}
                            <p-columnFilter type="text" field="Verified_Area_Count" display="menu"></p-columnFilter>
                            <p-sortIcon field="Verified_Area_Count"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Incomplete">{{'INCOMPLETE_APP'| translate}}
                            <p-columnFilter type="text" field="Incomplete" display="menu"></p-columnFilter>
                            <p-sortIcon field="Incomplete"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Rejected">{{'REJECTED_APP'| translate}}
                            <p-columnFilter type="text" field="Rejected" display="menu"></p-columnFilter>
                            <p-sortIcon field="Rejected"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pending">{{'PENDING_APP'| translate}}
                            <p-columnFilter type="text" field="Pending" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Pending"></p-sortIcon>
                        </th>
                        <th pSortableColumn="IntimationStage1">{{'INTIMATION_FOR_EARTHWORK'| translate}}
                            <p-columnFilter type="text" field="IntimationStage1" display="menu"></p-columnFilter>
                            <p-sortIcon field="IntimationStage1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VerifiedStage1">{{'VERIFIED1_SUBSIDY'| translate}}
                            <p-columnFilter type="text" field="VerifiedStage1" display="menu"></p-columnFilter>
                            <p-sortIcon field="VerifiedStage1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="IntimationStage2">{{'INTIMATION_FOR_CIVIL_CONSTRUCTION'| translate}}
                            <p-columnFilter type="text" field="IntimationStage2" display="menu"></p-columnFilter>
                            <p-sortIcon field="IntimationStage2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VerifiedStage2">{{'VERIFIED2_SUBSIDY'| translate}}
                            <p-columnFilter type="text" field="VerifiedStage2" display="menu"></p-columnFilter>
                            <p-sortIcon field="VerifiedStage2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="IntimationStage3">{{'INTIMATION_FOR_INSTALLATION'| translate}}
                            <p-columnFilter type="text" field="IntimationStage3" display="menu"></p-columnFilter>
                            <p-sortIcon field="IntimationStage3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VerifiedStage3">{{'VERIFIED3_SUBSIDY'| translate}}
                            <p-columnFilter type="text" field="VerifiedStage3" display="menu"></p-columnFilter>
                            <p-sortIcon field="VerifiedStage3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed_Stage1">{{'ASSISTANCE_DISBURSED_STAGE1'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed_Stage1" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed_Stage1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Amount_Stage1">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Disbursed_Amount_Stage1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Amount_Stage1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed_Stage2">{{'ASSISTANCE_DISBURSED_STAGE2'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed_Stage2" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed_Stage2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Amount_Stage2">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Disbursed_Amount_Stage2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Amount_Stage2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed_Stage3">{{'ASSISTANCE_DISBURSED_STAGE3'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed_Stage3" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed_Stage3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Amount_Stage3">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Disbursed_Amount_Stage3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Amount_Stage3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NoofBeneficiary">{{'NOOF_BENEFICIARY'| translate}}
                            <p-columnFilter type="text" field="NoofBeneficiary" display="menu"></p-columnFilter>
                            <p-sortIcon field="NoofBeneficiary"></p-sortIcon>
                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td>{{product.District}}</td>
                        <td>{{product?.Constituency}}</td>
                        <td>{{product?.Application_recevied }}</td>
                        <td>{{product?.Area}}</td>
                        <td>{{product?.Approved}}</td>
                        <td>{{product?.Verified_Area_Count}}</td>
                        <td>{{product?.Incomplete}}</td>
                        <td>{{product?.Rejected}}</td>
                        <td>{{product?.Pending}}</td>
                        <td>{{product?.IntimationStage1}}</td>
                        <td>{{product?.VerifiedStage1}}</td>
                        <td>{{product?.IntimationStage2}}</td>
                        <td>{{product?.VerifiedStage2}}</td>
                        <td>{{product?.IntimationStage3}}</td>
                        <td>{{product?.VerifiedStage3}}</td>
                        <td>{{product?.Assistance_Disbursed_Stage1}}</td>
                        <td>{{product?.Disbursed_Amount_Stage1}}</td>
                        <td>{{product?.Assistance_Disbursed_Stage2}}</td>
                        <td>{{product?.Disbursed_Amount_Stage2}}</td>
                        <td>{{product?.Assistance_Disbursed_Stage3}}</td>
                        <td>{{product?.Disbursed_Amount_Stage3}}</td>
                        <td>{{product?.NoofBeneficiary}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{disctrictConsistenceWiseData ?
                            disctrictConsistenceWiseData.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                        </p>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>